module.exports = __webpack_public_path__ + "media/images/dooh_1080x1920-07aa8cb3.svg";